import React from "react";

const FAQS = {
  "What does Komorebi do?": "Komorebi is a multidisciplinary design studio working at the intersection of strategy, branding, sustainability, and behaviour change. We work with conscious brands, NGOs, governments, and social enterprises who need someone to connect the dots between purpose and impact.",
  "How much does it cost?": "Our projects range from AED 3,500 for focused deliverables to AED 35,000 for full brand systems. Retainers start at AED 4,500/month. For the right projects, we also work on co-creation models — equity or revenue share. The first conversation is always free.",
  "How do I start?": "Simply email us at hey@komorebidesign.com and tell us what you're working on. No brief needed — just the problem you're trying to solve. We'll take it from there.",
  "What is the Earth Consciousness framework?": "Our proprietary model for systems change through design. Four steps: Break (interrupt the existing system), Seed (plant new consciousness), Rewire (change the behaviour), Repeat (make it systemic). Every Komorebi project moves through this arc.",
};

export default function ChatWidget() {
  const [open, setOpen] = React.useState(false);
  const [msgs, setMsgs] = React.useState([
    { id: "msg-init", role: "bot", text: "Hello. I'm here to help you think about conscious design, sustainable branding, and what Komorebi can do for you. What's on your mind?" },
  ]);
  const scrollRef = React.useRef(null);
  const nextIdRef = React.useRef(1);

  React.useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [msgs, open]);

  const ask = (q) => {
    const userId = `msg-${nextIdRef.current++}`;
    setMsgs((prev) => [...prev, { id: userId, role: "user", text: q }]);
    setTimeout(() => {
      const botId = `msg-${nextIdRef.current++}`;
      setMsgs((prev) => [...prev, { id: botId, role: "bot", text: FAQS[q] || "That's a thoughtful question. Email us at hey@komorebidesign.com and we'll give it the answer it deserves." }]);
    }, 400);
  };

  return (
    <div className="chat-bubble" data-testid="chat-bubble">
      <button className="chat-orb" onClick={() => setOpen((o) => !o)} aria-label="Open chat" data-testid="chat-orb-btn">
        <svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
      </button>
      <div className={`chat-box ${open ? "open" : ""}`}>
        <div className="chat-header">
          <span className="chat-header-title">Ask Komorebi</span>
          <button className="chat-close" onClick={() => setOpen(false)} aria-label="Close">×</button>
        </div>
        <div className="chat-messages" ref={scrollRef}>
          {msgs.map((m) => (
            <div key={m.id} className={`msg ${m.role}`}>{m.text}</div>
          ))}
        </div>
        <div className="chat-pills">
          {Object.keys(FAQS).map((q) => (
            <button key={q} className="pill" onClick={() => ask(q)} data-testid={`chat-pill-${q.slice(0,12)}`}>
              {q.length > 18 ? q.slice(0, 18) + "…" : q}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
